<template>
  <v-container grid-list-xl>
    <v-layout column>
      <v-flex v-if="Business && Campaigns && Campaigns.isActive">
        <div v-if="$vuetify.breakpoint.xsOnly">
          <div class="text-center mt-4">
            <img
              v-if="Business && Business.imageUrl"
              height="50"
              :src="Business.imageUrl"
              alt="Logo"
            />
            <div class="text-h5" v-if="Business.name">{{ Business.name }}</div>
            <div v-if="Business.phoneNumber">
              {{ Business.phoneNumber | USPhoneNumber }}
            </div>
            <div>
              <span v-if="Business.address">{{ Business.address }}</span
              >, <span v-if="Business.city">{{ Business.city }}</span
              >, <span v-if="Business.state">{{ Business.state }}</span>
              <span v-if="Business.zip">{{ Business.zip }}</span>
            </div>
          </div>
        </div>

        <div v-else>
          <v-layout class="mt-4 mx-2 mr-4" align-content-space-between row wrap>
            <v-flex>
              <img
                v-if="Business && Business.imageUrl"
                height="100"
                :src="Business.imageUrl"
                alt="Logo"
              />
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex>
              <div class="text-right">
                <div class="text-h5" v-if="Business.name">
                  {{ Business.name }}
                </div>
                <div>
                  <span v-if="Business.address">{{ Business.address }}</span
                  >, <span v-if="Business.city">{{ Business.city }}</span
                  >, <span v-if="Business.state">{{ Business.state }}</span>
                  <span v-if="Business.zip">{{ Business.zip }}</span>
                </div>
                <div v-if="Business.phoneNumber">
                  {{ Business.phoneNumber | USPhoneNumber }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex v-if="Campaigns && Campaigns.isActive">
        <v-img
          v-if="Campaigns.imageUrl"
          contain
          max-height="250"
          :src="Campaigns.imageUrl"
        ></v-img>
        <v-card-title
          class="text-h4 text-capitalize text-h6 text-md-body-1 text-lg-h4"
        >
          {{ Campaigns.name }}
        </v-card-title>
        <v-card-text
          class="text-body-2 text-md-body-1"
          style="max-height: 200px; overflow: auto"
        >
          {{ stripHTML(Campaigns.description) }}
        </v-card-text>
      </v-flex>
    </v-layout>
    <div v-if="Campaigns && Campaigns.isActive">
      <div v-if="Campaigns.type === 'sponsor'">
        <LimitDonation v-if="donationLimit" />
        <DonationSponsor v-else />
      </div>
      <div v-else>
        <DonationCampaign />
      </div>
    </div>
    <div v-if="Campaigns && !Campaigns.isActive">
      <v-card flat>
        <v-card-text>
          <v-layout row>
            <v-flex sm4>
              <lottie
                :options="defaultOptions"
                v-on:animCreated="handleAnimation"
              />
            </v-flex>
            <v-flex sm4>
              <v-card-text>
                <h2 class="display-1">This Link has Expired</h2>
                <span class="caption mt-2"
                  >Please contact customer support to receive a new URL</span
                >
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </div>
    <div class="text-right">
      Power by: <span>taleem.app</span> -
      <span class="caption">{{ version }}</span>
    </div>
  </v-container>
</template>

<script>
import LimitDonation from "@/modules/Campaign/view/Donation/DonationNoLimit.vue";
import DonationSponsor from "@/modules/Campaign/view/Donation/DonationSponsor.vue";
import DonationCampaign from "@/modules/Campaign/view/Donation/DonationCampaign.vue";
import donationService from "@/modules/Campaign/service.js";
import Lottie from "@/components/lottie.vue";
import * as animationData from "@/assets/lottie/pinjump.json";
const pjson = require("../../../../../package.json");
export default {
  name: "Camp-Donation",
  data() {
    return {
      Business: null,
      Campaigns: null,
      donationLimit: false,
      defaultOptions: {
        animationData: animationData.default,
      },
    };
  },
  computed: {
    version() {
      return pjson.version;
    },
  },
  components: {
    LimitDonation,
    DonationSponsor,
    DonationCampaign,
    Lottie,
  },
  created() {
    this.loadCampaign();
  },
  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    stripHTML(html) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      return tempElement.textContent || tempElement.innerText || "";
    },
    loadCampaign() {
      let code = this.$route.params.id;
      console.log("getting code 22", this.$route.params);
      donationService
        .getCampaignById(code)
        .then((response) => {
          console.log("response campaign", response);
          if (!response.data) {
            this.$router.push({ name: "pagenotfound" });
          }
          if (response.data.isActive === false) {
            this.$router.push({ name: "pagenotfound" });
          }
          this.Campaigns = response.data;
          this.Business = response.data.Business;
          console.log("test", this.Campaigns.metadata.preDefinedValue);
          if (this.Campaigns?.metadata?.preDefinedValue.length) {
            this.preDefinedValue = this.Campaigns.metadata.preDefinedValue;
            this.amount = this.preDefinedValue[0];
          }
          if (
            this.Campaigns &&
            this.Campaigns.metadata &&
            this.Campaigns.metadata.donationLimit
          ) {
            this.donationLimit = true;
          }

          // this.group = this.groupByCategory(this.Campaigns)
          // console.log('this.group', this.group)
        })
        .catch((error) => {
          console.log("error getting campaign", error);
          // this.$router.push({ name: "pagenotfound" });
        });
    },
  },
};
</script>

<style scoped></style>